(function(){
  angular.module('clientDashboardApp.common').directive('newNote', NewNote);

  function NewNote() {

    return {
      restrict: 'A',
      template: "<i class='fas fa-pencil clickable' ng-click='newNote()' uib-tooltip='Add a note for this {{noteSettings.noteType}}.' tooltip-append-to-body='true' tooltip-placement='auto top'></i>",
      scope: {
        rowItem: '=',
        noteSettings: '='
      },
      controller: NewNoteController
    }
  }
  NewNoteController.$inject = ['$scope','noteService','$timeout','$anchorScroll'];

  function NewNoteController($scope, noteService,$timeout,$anchorScroll) {
    $scope.newNote = function(){
      noteService.initNewNote($scope.rowItem,$scope.noteSettings.noteType);
      $scope.noteSettings.newNoteItem = $scope.rowItem;
      $scope.noteSettings.newNote = true;
      $scope.rowItem.newNote = true;
    }
  }
})();
